/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_ContinueInputs */

const en_us2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue that workout`)
};

const pt_br2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar esse treino`)
};

const es_419_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar ese entrenamiento`)
};

const pt_pt2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar esse treino`)
};

const fr_fr2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer cette séance`)
};

const de_de2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training fortsetzen`)
};

const it_it2_workout_open_continue = /** @type {(inputs: Workout_Open_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua quell'allenamento`)
};

/**
* | output |
* | --- |
* | "Continue that workout" |
*
* @param {Workout_Open_ContinueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_continue = /** @type {((inputs?: Workout_Open_ContinueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_ContinueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_continue(inputs)
	if (locale === "es-419") return es_419_workout_open_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_continue(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_continue(inputs)
	if (locale === "de-DE") return de_de2_workout_open_continue(inputs)
	if (locale === "it-IT") return it_it2_workout_open_continue(inputs)
	return en_us2_workout_open_continue(inputs)
});
export { workout_open_continue as "workout.open_continue" }